import './logo.scss'

export const HughesnetLogo = () => {

    return <div className="hughesnet-logo">
        <img src="https://hughesapp.appshughes.com/images/logo_new.svg"/>
    </div>
}